// extracted by mini-css-extract-plugin
module.exports = {"logo":"layout-module--logo--2WAdk","allContent":"layout-module--allContent--3l8FL","mainContent":"layout-module--mainContent--3OkZq","portfolio":"layout-module--portfolio--3crhT"};